export default __webpack_public_path__ + "static/media/attila-and-flowers.e66aedf6.jpeg";